module.exports = __webpack_public_path__ + "media/images/PAI_partners-b105be61.png";